export default "__VITE_ASSET__BMP$uzNg__"